import SpinnerDots from './SpinnerDots'

export default SpinnerDots
